// extracted by mini-css-extract-plugin
export default {"documentsWrapper":"LandscapeIndicatorSupportingDocumentsTemplate_documentsWrapper__M2djB"};